import { observer } from "mobx-react-lite";

// hooks
import { useLzssStore } from "../../../../../../../store/hooks";

// types
import { EnAreaNames, EnFormNames, } from "../../../../../../../store/caseSettingsStore";

// components
import { TopViewCase } from "../../topViewCase/TopViewCase";
import { UserLayout } from "../../../../../../shared/user/layout/UserLayout";
import { PatientSection } from "./patientSection/PatientSection";
import { CurrentTreatmentSection } from "./currentTreatmentSection/CurrentTreatmentSection";
import { TreatmentProgramSection } from "./treatmentProgramSection/TreatmentProgramSection";

// lib
import { useViewCase } from "../../../viewCaseCreator/useViewCase";
import { Observations } from "./obervations/Observations";

export const LzssViewCase = observer(() => {
  const lzssStore = useLzssStore();
  const {isCase} = useViewCase(
    EnAreaNames.rheumatology,
    EnFormNames.lzss,
    lzssStore
  );

  return (
    <UserLayout>
      {isCase && (
        <>
          <TopViewCase caseStore={lzssStore}/>
          <PatientSection/>
          <CurrentTreatmentSection/>
          <TreatmentProgramSection/>
          <Observations/>
        </>
      )}
    </UserLayout>
  );
});
